var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrButton',{staticClass:"btn-copy",attrs:{"color":_vm.color},on:{"click":_vm.copy}},[_vm._v(_vm._s(_vm.hasCopied ? 'Copiado!' : _vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }